// extracted by mini-css-extract-plugin
export default {"wrapper":"Contacts_wrapper__A2q+k","content":"Contacts_content__e8iOI"};